import {ref, computed} from 'vue'
import {defineStore} from 'pinia'

export default defineStore('notification', () => {
  const text = ref('')
  const icon = ref('')
  const auto = ref(false)
  const dialogNotification = ref(false)
  const poorNetworkToast = ref(false)
  const hasMessage = computed(() => text.value.length && icon.value.length)
  const hasDialogNotification = computed(() => dialogNotification.value)
  const hasPoorNetworkToast = computed(() => poorNetworkToast.value)
  let timer = 0

  function showMessage({text, icon, auto}) {
    this.$patch({text, icon, auto})
    clearTimeout(timer)
    if (auto) {
      // TODO: call hide message
      timer = setTimeout(() => {
        this.$patch({
          text: '',
          icon: '',
          auto: false,
        })
      }, 1500)
    }
  }

  function hideMessage() {
    this.$patch({
      text: '',
      icon: '',
      auto: false,
    })
    if (auto.value) {
      clearTimeout(timer)
    }
  }

  function showDialogNotification({dialogNotification}) {
    this.$patch({dialogNotification})
  }

  function showPoorNetworkToast({poorNetworkToast}) {
    this.$patch({poorNetworkToast})
  }

  return {
    text,
    icon,
    auto,
    hasMessage,
    poorNetworkToast,
    hasDialogNotification,
    hasPoorNetworkToast,
    dialogNotification,
    showMessage,
    hideMessage,
    showDialogNotification,
    showPoorNetworkToast,
  }
})
